import { detectAdblock } from './detector.js';

export { detectAdblock };

// For browser/UMD usage, attach to window if available
if (typeof window !== 'undefined') {
  window.adblockDetector = {
    detectAdblock,
  };
}
